"use strict";

var _themeSections = require("@shopify/theme-sections");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Large video banner
 * ------------------------------------------------------------------------------
 * Used to display a youtube video when clicked
 *
 * @namespace largeVideoBanner
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '.large-video-banner',
  iframe: '.video_iframe'
};
/**
 * Register the `large-video-banner` section type.
 */

(0, _themeSections.register)('large-video-banner', {
  /**
   * Add active class on click
   */
  activeOnClick: function activeOnClick() {
    var _this = this;

    var container = document.querySelector(selectors.container);
    var video = this.container.getElementsByClassName('icon__play')[0]; // const videoElem = this.container.querySelector('iframe');

    video.addEventListener('click', function () {
      _this.container.classList.add(_cssClasses["default"].active); // videoElem.src = `${videoElem.getAttribute('data-src')}&autoplay=1`;

    });
    this.nodeSelectors = {
      container: container
    };
  },

  /**
   * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
   */
  onLoad: function onLoad() {
    this.activeOnClick();
  }
});